import type { LDFlagValue } from 'launchdarkly-js-client-sdk';
import { useFlags as useLaunchDarklyFlags } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

import { type C99FlagSet, type FEATURE_FLAG_VALUE } from '@/constants/featureFlags';
import type C99FeatureFlagEvent from '@/events/C99FeatureFlagEvent';
import { C99FeatureFlagEventType } from '@/events/C99FeatureFlagEvent';
import { WEB_STORAGE, getFeatureFlagOverrides } from '@/helper/user-preferences';

export const useFeatureFlag = (flag: FEATURE_FLAG_VALUE): LDFlagValue => {
  const featureFlags = useAllFeatureFlags();
  return featureFlags[flag];
};

export const useAllFeatureFlags = (): C99FlagSet => {
  const [flagOverrides, setFlagOverrides] = useState(getFeatureFlagOverrides());

  useEffect(() => {
    const handleStorageChange = (event: C99FeatureFlagEvent) => {
      const { detail } = event;
      if (detail.key === WEB_STORAGE.FEATURE_FLAG_OVERRIDES) {
        setFlagOverrides(detail.newValue ?? {});
      }
    };

    window.addEventListener(C99FeatureFlagEventType, handleStorageChange);
    return () => window.removeEventListener(C99FeatureFlagEventType, handleStorageChange);
  }, []);

  const flags = useLaunchDarklyFlags<C99FlagSet>();
  const combinedFlags: C99FlagSet = {
    ...flags,
    ...flagOverrides,
  };

  return combinedFlags;
};
